import type { BigQueryData, BigQueryEventName } from '../../../events/bigQuery';
import { LINKS } from '../constants';

type LogoMakerLinkEventNameBase = (typeof LINKS)[keyof typeof LINKS]['bigQuery'];

export const bigQuery = (id: number | undefined, type: LogoMakerLinkEventNameBase): BigQueryData => ({
    group: 'header_clicks',
    type: `clicked_header.${type}` as BigQueryEventName,
    user: {
        id,
        navigation_mode: 'logo_maker',
    },
});
